import { render } from "./ProjectSelector.vue?vue&type=template&id=6a581320&scoped=true"
import script from "./ProjectSelector.vue?vue&type=script&lang=js"
export * from "./ProjectSelector.vue?vue&type=script&lang=js"

import "./ProjectSelector.vue?vue&type=style&index=0&id=6a581320&scoped=true&lang=css"

import exportComponent from "/home/ysm/workspace/kft/translate/translate-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a581320"]])

export default __exports__